import { Node, mergeAttributes } from '@tiptap/core';
import { NodeViewWrapper, ReactNodeViewRenderer } from '@tiptap/react';
import type { NodeViewProps } from '@tiptap/react';
import React from 'react';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    variable: {
      insertVariable: (name: string) => ReturnType;
    };
  }
}

const VariableChip: React.FC<NodeViewProps> = ({ node }) => {
  const name = node.attrs.name as string;
  return (
    <NodeViewWrapper as="span" className="inline-block align-baseline">
      <span
        contentEditable={false}
        className="inline-flex items-center px-2 py-0.5 mx-0.5 text-xs font-medium rounded-full bg-purple-100 text-purple-800 border border-purple-300 select-none"
      >
        <span className="font-mono text-[10px] text-purple-500 mr-0.5">{'{{'}</span>
        {name}
        <span className="font-mono text-[10px] text-purple-500 ml-0.5">{'}}'}</span>
      </span>
    </NodeViewWrapper>
  );
};

export const VariableNode = Node.create({
  name: 'variable',
  group: 'inline',
  inline: true,
  atom: true,
  selectable: true,
  draggable: false,

  addAttributes() {
    return {
      name: {
        default: '',
        parseHTML: (el) => el.getAttribute('data-variable'),
        renderHTML: (attrs) => ({ 'data-variable': attrs.name }),
      },
    };
  },

  parseHTML() {
    return [{ tag: 'span[data-variable]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ['span', mergeAttributes(HTMLAttributes), ''];
  },

  addNodeView() {
    return ReactNodeViewRenderer(VariableChip);
  },

  addCommands() {
    return {
      insertVariable:
        (name: string) =>
        ({ commands }) =>
          commands.insertContent({ type: this.name, attrs: { name } }),
    };
  },
});
